import { FlexWrapper, RewardBalance, Text } from '@intigral/shared';
import { __ } from '../../../../translations';
import { isKidsProfile } from '../../../../utils/user';

const ScoreCard = ({ scoreCardProps }) => {
    const { activeBadge, balance, badgeLoading, balanceLoading, termsLink, getRedeemCTA = null } = scoreCardProps;

    return (
        <FlexWrapper flexDirection="column" gap="3x">
            <RewardBalance
                statusLabel={__(activeBadge?.name)}
                title={__('your_current_balance')}
                currentPoints={balance}
                pointsLabel={__('points')}
                isLoading={badgeLoading || balanceLoading}
                cta={getRedeemCTA?.() || null}
                kidsText={isKidsProfile() && __('gamification_kids_redeem_text')}
            />
            <Text as="span" margin="0" color="gray" size="10" alignment="start">
                {__('points_expiry_alert')}{' '}
                <a
                    href={termsLink}
                    target="_blank"
                    className="primary-brand"
                    data-test-id="score-card-terms-and-conditions-link"
                >
                    {__('terms_and_conditions')}
                </a>
            </Text>
        </FlexWrapper>
    );
};

export default ScoreCard;
